import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Root = styled(Stack, {
  shouldForwardProp: (prop) => prop !== "$isPositive",
})<{ $isPositive: boolean }>(({ $isPositive, theme }) => ({
  flexDirection: "row",
  alignItems: "center",
  gap: theme.spacing(0.25),
  fontSize: 12,
  fontWeight: 500,
  color: $isPositive ? theme.palette.success.main : theme.palette.error.main,

  "& .MuiSvgIcon-root": {
    fontSize: 12,
  },
}));
